export enum accessPermission {
    view = 'view',
    create = 'create',
    edit = 'edit',
    delete = 'delete',
    full = 'full'
}

export enum PermissionCodes {
    "create" = "Создание",
    "view" = "Просмотр",
    "delete" = "Удаление",
    "edit" = "Редактирование",
    "full" = "Все",
}